import {svgIconWrapper} from '../svg-icon-wrapper';

import TaskRegularAi from './task-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TaskRegularAi {...validProps} />;
}

SvgComponent.iconName = 'task-regular-ai';

export const TaskRegularAiIcon = svgIconWrapper(SvgComponent);
